module.exports = __webpack_public_path__ + "media/St 4-thermostat-incorrect.30f74fe5.wav";